const availableWidth = "--available-width";
const availableHeight = "--available-height";
const anchorWidth = "--anchor-width";
const anchorHeight = "--anchor-height";
const transformOrigin = "--transform-origin";
export {
  anchorHeight,
  anchorWidth,
  availableHeight,
  availableWidth,
  transformOrigin
};
//# sourceMappingURL=CommonPositionerCssVars.js.map
